// extracted by mini-css-extract-plugin
export default {"uploadImage":"imageStyles_uploadImage__v1ujG"};